import { ILabel, ISpace, IUnit } from 'shared/interfaces'
import { TSelectOption } from '../types'
import { Label, Unit } from '../__gql-types'

export const formatToOptionsById = <T extends Label | Unit>({ id, name }: T) => ({ value: id ?? '', label: name })

export const formatToOptions = <T extends Label | IUnit>({ id, name }: T) => ({ value: id ?? '', label: name })

export const formatLabelOptions = (labels: Label[]): TSelectOption[] =>
  labels.map(({ id, alias, name }) => ({
    label: alias,
    value: id ?? '',
    title: name
  }))

export const mapLabelOptions = (labels: Label[]) => {
  return labels.map(({ id, alias }) => ({
    key: id,
    value: id,
    title: alias,
    label: alias
  }))
}

export const getUnits = (labels: Label[], labelValue?: string | number) => {
  const currentLabel = labels && labels.find((item: Label) => item.id === `${labelValue}`)

  return currentLabel && currentLabel.units ? currentLabel.units : []
}


export const getSpaceUnits = (labels: Label[], space?: ISpace) => {
  if (!space || !space.labels) {
    return  []
  }
  const labelIds = space.labels.map((label) => label.id)
  const selectedLabels = labels.filter((label) => labelIds.includes(label.id ?? ''))
  const units = selectedLabels.map((label) => label?.units || []).flat()
  return units || []
}


export const formatUnitsToOptions = (labels: Label[], labelValue?: string | number) => {
  if (!labels) return []

  const currentUnits = getUnits(labels, labelValue)
  return currentUnits.map(formatToOptionsById) || []
}

export const getCountryCodes = (labels: Label[], labelValue?: string | number): string[]=> {
  const currentLabel = labels && labels.find((item: Label) => item?.id === `${labelValue}`)

  return currentLabel && currentLabel?.country_codes ? currentLabel.country_codes : []
}

export const formatCountryCodesToOptions = (labels: Label[], labelValue?: string | number) => {
  if (!labels) return []

  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })
  const currentLabel = getCountryCodes(labels, labelValue)

  return currentLabel.map((code) => ({ value: code, label: code, title: regionNames.of(code) }))
}

export const getSpaceCountryCodes = (space: ISpace) => {
  return space?.labels ? [...new Set(space?.labels.map((item: ILabel) => item.country_codes).flat())] : []
}

export const formatSpaceCountryCodesToOptions = (space: ISpace | undefined) => {
  if (!space) return []

  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })

  const countryCodes = getSpaceCountryCodes(space)

  return countryCodes.map((code: string) => ({ value: code, label: code, title: regionNames.of(code) }))
}
